<template>
  <div class="services-card">
    <nuxt-link class="services-card__head" :to="{ name: 'home', params: { chapters: useSlugTransform(slug) } }">
      <div class="services-card__icon">
        <NuxtIcon v-if="icon" :name="useServicesIconName(icon)" filled></NuxtIcon>
      </div>
      <p
        class="services-card__title"
        >{{ title }}
      </p>

      <UIButton type="button" variant="primary" size="s">
        <NuxtIcon class="icon" name="IconAngleRight"></NuxtIcon>
      </UIButton>
    </nuxt-link>

    <ul v-if="children" class="services-card__list">
      <li v-for="(item, index) in children" :key="index" class="services-card__item">
        <nuxt-link
          :to="{ name: 'home', params: { chapters: useSlugTransform(item.full_slug) } }"
          class="services-card__link"
          >{{ item.title }} <i class="icon icon--arrow-right"></i>
          <NuxtIcon class="icon" name="IconAngleRight"></NuxtIcon>
        </nuxt-link>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import './styles.scss';
import type { ServicesResults } from '~/types/pages';
import { useServicesIconName, useSlugTransform } from '#imports';

interface Props {
  title: string;
  slug: string;
  icon: string;
  children?: ServicesResults[];
}

defineProps<Props>();
</script>
